import { ApiClearBuyProductBadge } from '../types.wp'
import { DSNCDealsBadge } from 'shared-definitions/types'
import { imageMapper } from './imageMapper'
import { PLinkMapperOpts } from './pLinkMapper'

export function productBadgesMapper(
  input: ApiClearBuyProductBadge[],
  opts: PLinkMapperOpts
): DSNCDealsBadge[] {
  return input.map(badge => ({
    name: badge.name,
    year: badge.year,
    images: badge.image.map(img => imageMapper(img, opts)),
  }))
}
